<app-drop-down-single-con-id [data]="usuarioEstados"
                      (elementoSeleccionado)="filterEstado($event)"
                      [valorPreSeleccionado]="usuarioEstados[0]"
                      [width]="'200px'"
                      [height]="'30px'"></app-drop-down-single-con-id>
